import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../api/ApiSettings";
import * as errorSlice from "../error/errorSlice";

const initialState = {
  complaintTypes: [],
  selectedClient: '',
  selectedComplaintType: '',
}

// export const getComplaint = createAsyncThunk('complaint/getCustomerComplaintTypes', async () => {
//   const response = await fetch(`${API_URL}complaint/getCustomerComplaintTypes`);
//   const data = await response.json(); 
//   return data;
// });

export const getComplaint = createAsyncThunk('complaint/getCustomerComplaintTypes', async (_, { rejectWithValue,dispatch }) => {
  try {
    const response = await fetch(`${API_URL}complaint/getCustomerComplaintTypes`);
    const data = await response.json(); 
    if (response.status === 200) {
      return data;
    } else {
      console.error("Błąd pobierania typów reklamacji");
      dispatch(errorSlice.setError("Błąd pobierania typów reklamacji"));
      return rejectWithValue("Błąd pobierania typów reklamacji");
    }
  } catch (error) {
    console.error("Błąd pobierania typów reklamacji:", error);
    dispatch(errorSlice.setError("Błąd pobierania typów reklamacji"));
    return rejectWithValue("Błąd pobierania typów reklamacji");
  }
});

const complaintTypesSlice = createSlice({
  name: "complaintTypes",
  initialState,
  reducers: {
    setSelectClient: (state, action) =>{
      state.selectedClient = action.payload;
    },
    setSelectComplaintType: (state, action) =>{
      state.selectedComplaintType = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getComplaint.fulfilled, (state, action) => {
        state.complaintTypes = action.payload;
      })
      .addCase(getComplaint.rejected, (state, action) => {
        console.error("Error during getComplaint:", action.payload);
        errorSlice.setError(action.payload);
      });
  }

});

export const { setComplaint, setSelectClient,setSelectComplaintType } = complaintTypesSlice.actions;

export default complaintTypesSlice.reducer;